import { cn } from '@immo/ui-kit';

/**
 * A key cap. Token composition only (mono type, neutral surface, small radius) —
 * the same treatment the design uses for the `⌘K` chip and the `↵` hint.
 */
export function Kbd({ children, className }: { readonly children: React.ReactNode; readonly className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 shrink-0 items-center rounded-sm border border-border bg-canvas px-1.5 font-mono text-xs font-medium text-text-tertiary',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
